import React, { useState } from "react";

const FieldSelector = ({
  table,
  tableLabel,
  fields,
  selectedFields,
  onToggleField,
  onToggleAll,
  onRemoveTable,
  showRemove = false,
}) => {
  const [allSelected, setAllSelected] = useState(false);

  if (!fields || fields.length === 0) return null;

  const toggleAll = () => {
    setAllSelected(!allSelected);
    onToggleAll(table, !allSelected);
  };

  return (
    <div className="mb-4 border rounded p-3 bg-white shadow-sm">
      <div className="d-flex justify-content-between align-items-center mb-2">
        <h5 className="fw-bold mb-0">Fields from {tableLabel}</h5>

        <div className="d-flex gap-2">
          <button
            className="btn btn-sm btn-outline-secondary"
            onClick={toggleAll}
          >
            {allSelected ? "Deselect All" : "Select All"}
          </button>

          {showRemove && (
            <button
              className="btn btn-sm btn-outline-danger ml-1"
              onClick={() => onRemoveTable(table)}
            >
              ❌ Remove Table
            </button>
          )}
        </div>
      </div>

      <div className="container">
        <div className="row">
          {fields.map((field) => (
            <div key={field.code} className="col-md-4 mb-2">
              <label className="form-check-label">
                <input
                  type="checkbox"
                  className="form-check-input me-2"
                  checked={selectedFields.includes(field.code)}
                  onChange={() => onToggleField(table, field.code)}
                />
                {field.label}
              </label>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FieldSelector;
